<div class="scheme-preview">
    <div class="preview-header">
        <h3>{{ 'SCHEMEPREVIEW.HEADER.TITLE' | translate }}</h3>
        <a href="{{ schemeDownloadUrl(primaryScheme) }}" target="_blank" mat-stroked-button color="primary">{{
            'SCHEMEPREVIEW.HEADER.BUTTON.LABEL' | translate
        }}</a>
    </div>
    <div class="preview-content">
        <img src="{{ schemeDownloadUrl(primaryScheme, true) }}" />
    </div>
</div>
